import React, { memo } from "react";
import "../../../css/FilterAdminUsers.css";
import { useTranslation } from "react-i18next";

function FilterRoleSteps({ stepName, onStepNameChange }) {
  const { t } = useTranslation();

  const handleChange = (e) => {
    const clean = e.target.value.replace(/[^a-zA-Z0-9-_^\s]/g, "");
    onStepNameChange(clean);
  };

  return (
    <div
      className="filter-container"
      style={{
        marginBottom: "1rem",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
      }}
    >
      <input
        id="stepFilter"
        type="text"
        className="filter-container-input-username"
        placeholder={t("filterSteps.stepNamePlaceholder")}
        value={stepName}
        onChange={handleChange}
        pattern="[a-zA-Z0-9-_^\\s]+"
        title={t("filterSteps.stepNameTitle")}
        style={{ flex: 1 }}
         autoComplete="off"  
      />
    </div>
  );
}

export default memo(FilterRoleSteps);
